import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=6ac6e28e"
import script from "./Groups.vue?vue&type=script&lang=ts"
export * from "./Groups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac6e28e')) {
      api.createRecord('6ac6e28e', component.options)
    } else {
      api.reload('6ac6e28e', component.options)
    }
    module.hot.accept("./Groups.vue?vue&type=template&id=6ac6e28e", function () {
      api.rerender('6ac6e28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Groups.vue"
export default component.exports